import script from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppSlippageForm.vue?vue&type=style&index=0&id=38a76f23&scoped=true&lang=css"
script.__scopeId = "data-v-38a76f23"

export default script